import type { ReactNode } from "react";

export type SwotAlertTone = "info" | "warning" | "error" | "success";

export function SwotAlert(props: { readonly title: string; readonly tone?: SwotAlertTone | undefined; readonly children?: ReactNode | undefined; readonly className?: string | undefined }) {
  const tone = props.tone ?? "info";
  return (
    <section className={`swot-alert swot-alert--${tone} ${props.className ?? ""}`.trim()} role={tone === "error" ? "alert" : "status"} aria-live={tone === "error" ? "assertive" : "polite"}>
      <strong className="swot-alert__title">{props.title}</strong>
      {props.children ? <div className="swot-alert__body">{props.children}</div> : null}
    </section>
  );
}
